<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="py-5">
    <div class="relative w-full pl-6">
      <button class="absolute left-0 top-0 h-6 w-6" @click="handleClick">
        <IconCaret
          :direction="isOpen ? 'up' : 'down'"
          class="h-full w-full text-blue-400"
        />
      </button>
      <div class="pl-3">
        <h3
          v-if="itemData.name"
          class="text-sm font-bold leading-6 tablet:line-clamp-4 tablet:text-base"
          :class="isOpen && 'mb-2'"
        >
          {{ itemData.name }}
        </h3>
        <p
          v-if="itemData.description && isOpen"
          class="element-description text-sm leading-5 text-gray-600 tablet:line-clamp-6"
          v-html="provideSanitized(itemData.description)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IItem } from '@/components/Shared/Suite/Faq/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IItem;
    itemIndex: number;
    urlConnector?: TUrlConnector;
  }

  const props = defineProps<IProps>();

  const isOpen = ref<boolean>(props.itemIndex === 0);

  const handleClick = (): void => {
    isOpen.value = !isOpen.value;
  };
</script>

<style lang="scss" scoped>
  .element-description:deep(a) {
    @apply font-bold text-blue-400 underline;
  }

  .element-description:deep(ul) {
    padding-left: 1.75rem; // 28px
    list-style-type: disc;
  }

  .element-description:deep(ol) {
    padding-left: 1.5rem;
    list-style-type: decimal;
  }
</style>
